<template>
  <div>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-view-list</v-icon>
      <v-toolbar-title>Nature of Loss 2</v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew" v-if="nol1Mode !== 'Query'">
          New Nature of Loss 2
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.nol2 }}</td>
                <td class="text-xs-left">{{ row.item.nol2desc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    :review="nol1Mode !== 'Query'"
                    @review="doReview(row.item)"
                    query
                    @query="doQuery(row.item)"
                    :remove="nol1Mode !== 'Query'"
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <v-dialog v-model="nol2Review" width="800px" persistent>
      <v-card>
        <v-toolbar v-if="!newMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Nature of Loss 2 </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create Nature of Loss 2</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.nol1 }}</v-subheader>
                <div class="queryValue">{{ form.nol1 }} - {{ nol1longDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode || reviewMode"
                  :label="labels.nol2"
                  v-model="form.nol2"
                  :error-messages="errors.collect('nol2')"
                  data-vv-name="nol2"
                  :data-vv-as="labels.nol2"
                  v-validate="'required|max:2'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  :label="labels.nol2desc"
                  v-model="form.nol2desc"
                  :error-messages="errors.collect('nol2desc')"
                  data-vv-name="nol2desc"
                  :data-vv-as="labels.nol2desc"
                  v-validate="'required|max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ createdDate }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ modifiedDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose" :loading="loading">Cancel</v-btn>
          <v-btn color="primary" v-if="!queryMode" text @click.native="doSaveNOL2" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected Nature of Loss 2?</p>
      <div class="queryValue">{{ selectedNol2.nol2 }} - {{ selectedNol2.nol2desc }}</div>
    </confirm>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      headers: [{ text: 'Nature of Loss 2', value: 'nol2' }, { text: 'Description', value: 'nol2desc' }, TableConst.tableActionHeader],
      nol2Review: false,
      newMode: false,
      labels: {
        nol1: 'Nature of Loss 1',
        nol2: 'Nature of Loss 2',
        nol2desc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        nol1: null,
        nol2: null,
        nol2desc: null
      },
      nol1longDesc: null,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: null,
      modifiedDate: null,
      selectedNol2: {
        nol1: null,
        nol2: null,
        nol2desc: null
      },
      promptRemove: false,
      queryMode: false,
      reviewMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
    this.form.nol1 = this.nol1Param
    this.nol1longDesc = this.nol1longDescParam
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('clmNOL2ManagementInit')])
      const apiURI = this.menu.getClmNol2List
      if (apiURI) {
        this.loading = true
        const expand = { nol1: this.nol1Param }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((map) => {
                const convertList = {
                  nol2: map.nol2,
                  nol2desc: map.nol2desc
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.nol2Review = true
      this.createdDate = new Date()
    },
    async doReview(obj) {
      this.doFetchNol2(obj)
      this.newMode = false
      this.reviewMode = true
    },
    async doQuery(obj) {
      this.doFetchNol2(obj)
      this.queryMode = true
      this.newMode = false
      this.reviewMode = false
    },
    doFetchNol2(obj) {
      this.resetValidator()
      this.resetMessages()
      if (obj) {
        this.loading = true
        this.newMode = false
        this.queryMode = false
        this.reviewMode = false
        const apiURI = this.menu.getNol2
        if (apiURI) {
          const expand = { nol1: this.nol1Param, nol2: obj.nol2 }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.form.nol1 = data.clmNol2.nol1
                this.form.nol2 = data.clmNol2.nol2
                this.form.nol2desc = data.clmNol2.nol2desc
                this.nol1longDesc = data.longDesc
                this.createdBy = data.createdBy
                this.createdDate = formatDisplayDate(data.createdDate)
                this.modifiedBy = data.modifiedBy
                this.modifiedDate = formatDisplayDate(data.modifiedDate)
                this.nol2Review = true
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doSaveNOL2() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createClmNol2
      if (apiURI) {
        this.loading = true
        this.$http
          .post(apiURI, this.form)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateClmNol2
      if (apiURI) {
        this.loading = true
        this.$http
          .put(apiURI, this.form)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
              this.doClose()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doPromptRemove(obj) {
      this.resetMessages()
      if (obj && obj.nol2) {
        this.promptRemove = true
        obj.nol1 = this.form.nol1
        this.selectedNol2 = obj
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedNol2.nol2) {
        this.loading = false
        const apiURI = this.menu.deleteClmNol2
        if (apiURI) {
          const expand = this.selectedNol2
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.doInit(true)
              this.loading = false
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
              this.loading = false
            })
        }
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.form.nol2 = null
      this.form.nol2desc = null
      this.nol2Review = false
      setTimeout(() => {
        this.newMode = false
      }, 200)
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmNOL2Param.menu
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    nol1Mode: {
      type: String,
      default: ''
    },
    nol1Param: {
      type: String,
      default: ''
    },
    nol1longDescParam: {
      type: String,
      default: ''
    }
  }
}
</script>
